import { toast } from "sonner";

/**
 * The two sentences a Quality Guard scan announces itself with, named once because the
 * project one is raised from both the dashboard and the configuration page.
 */
export const QUALITY_GUARD_ENTITY_SCAN_STARTED_MESSAGE = "Quality Guard entity scan started";
export const QUALITY_GUARD_PROJECT_SCAN_STARTED_MESSAGE = "Quality Guard project scan started";

/** How long a scan announcement stays up — sonner's own informational default, named so the dismissal below uses the same number. */
export const QUALITY_GUARD_SCAN_TOAST_DURATION_MS = 4000;

/**
 * Announces that a scan started, and takes the announcement away on a wall clock.
 *
 * These toasts land in the corner the Quality Guard panel's foot occupies, and sonner
 * pauses a toast's own countdown while the pointer is over the toaster or the tab is
 * hidden, so a reader reaching for a control underneath holds the toast open for exactly
 * as long as they are reaching for it. This timer does not pause, so the panel comes back
 * whatever the pointer is doing.
 *
 * Nothing here is actionable: the scan's progress is reported by the panel itself.
 */
export function notifyQualityGuardScanStarted(message: string): void {
  const toastId = toast.success(message, { duration: QUALITY_GUARD_SCAN_TOAST_DURATION_MS });
  setTimeout(() => {
    toast.dismiss(toastId);
  }, QUALITY_GUARD_SCAN_TOAST_DURATION_MS);
}
